import { createContext, useContext } from "react";

/**
 * Drop anything (TT-1231), app-wide. The provider (`app/DropAnything.js`)
 * owns the start modals and the routing from a link to the right one; pages
 * reach it here.
 *
 *   startFromButton(kind)   a start button: prescan the clipboard, open the
 *                           modal for `kind` (null = Live) prefilled or not
 *   openStartModal(kind, link)
 *   registerRefresh(fn)     what to call after a start (the documents list);
 *                           returns the unregister
 *   setLiveConflict(bool)   the page shows a live tap that is running, so a
 *                           dropped link must not start another over it
 */
const DropAnythingContext = createContext({
  startFromButton: () => {},
  openStartModal: () => {},
  registerRefresh: () => () => {},
  setLiveConflict: () => {},
});

export const useDropAnything = () => useContext(DropAnythingContext);

export default DropAnythingContext;
